import { isCSSVar } from '../../render/dom/is-css-var.mjs';
import { transformProps } from '../../render/utils/keys-transform.mjs';
import { isHTMLElement } from '../../utils/is-html-element.mjs';
import { MotionValue } from '../../value/index.mjs';
import { createSelectorEffect } from '../utils/create-dom-effect.mjs';
import { createEffect } from '../utils/create-effect.mjs';
import { buildTransform } from './transform.mjs';
var originProps = new Set(["originX", "originY", "originZ"]);

var addStyleValue = function addStyleValue(element, state, key, value) {
  var render = undefined;
  var computed = undefined;

  if (transformProps.has(key)) {
    if (!state.get("transform")) {
      // If this is an HTML element, we need to set the transform-box to fill-box
      // to normalise the transform relative to the element's bounding box
      if (!isHTMLElement(element) && !state.get("transformBox")) {
        addStyleValue(element, state, "transformBox", new MotionValue("fill-box"));
      }

      state.set("transform", new MotionValue("none"), function () {
        element.style.transform = buildTransform(state);
      });
    }

    computed = state.get("transform");
  } else if (originProps.has(key)) {
    if (!state.get("transformOrigin")) {
      state.set("transformOrigin", new MotionValue(""), function () {
        var _state$latest$originX, _state$latest$originY, _state$latest$originZ;

        var originX = (_state$latest$originX = state.latest.originX) !== null && _state$latest$originX !== void 0 ? _state$latest$originX : "50%";
        var originY = (_state$latest$originY = state.latest.originY) !== null && _state$latest$originY !== void 0 ? _state$latest$originY : "50%";
        var originZ = (_state$latest$originZ = state.latest.originZ) !== null && _state$latest$originZ !== void 0 ? _state$latest$originZ : 0;
        element.style.transformOrigin = "".concat(originX, " ").concat(originY, " ").concat(originZ);
      });
    }

    computed = state.get("transformOrigin");
  } else if (isCSSVar(key)) {
    render = function render() {
      element.style.setProperty(key, state.latest[key]);
    };
  } else {
    render = function render() {
      element.style[key] = state.latest[key];
    };
  }

  return state.set(key, value, render, computed);
};

var styleEffect = /*@__PURE__*/createSelectorEffect( /*@__PURE__*/createEffect(addStyleValue));
export { addStyleValue, styleEffect };